
    import { cloudinaryUrl } from './cloudinary.js'
    import { initIris } from './iris.js'
    initIris()

    fetch('/data/about.json').then(r => r.json()).then(data => {
      if (data.bio) document.getElementById('aboutBio').textContent = data.bio
      const photosEl = document.getElementById('aboutPhotos')
      if (data.photos && data.photos.length) {
        photosEl.innerHTML = data.photos.map(p =>
          p.url
            ? `<div class="about-photo"><img src="${cloudinaryUrl(p.url, 'w_800,q_auto,f_auto')}" alt="${p.alt || ''}" loading="lazy"></div>`
            : `<div class="about-photo about-photo--empty"></div>`
        ).join('')
      }
      const logosEl = document.getElementById('clientLogos')
      if (data.clients && data.clients.length) {
        logosEl.innerHTML = data.clients.map(c =>
          c.logo
            ? `<img src="${cloudinaryUrl(c.logo, 'w_200,q_auto,f_auto')}" alt="${c.name}" class="client-logo">`
            : `<span class="client-name">${c.name}</span>`
        ).join('')
      }
    }).catch(() => {})

    const navToggle   = document.querySelector('.nav-toggle')
    const mobileNav   = document.getElementById('mobileNav')
    const mobileClose = document.querySelector('.mobile-nav-close')
    navToggle.addEventListener('click', () => mobileNav.classList.add('open'))
    mobileClose.addEventListener('click', () => mobileNav.classList.remove('open'))
    document.querySelectorAll('.mobile-nav-link').forEach(l => l.addEventListener('click', () => mobileNav.classList.remove('open')))
  